 
import { gql } from '@apollo/client';

export const GET_MAKES_BY_PARTIAL_MATCH = gql`
  query GetMakesByPartialMatch($makeName: String!, $context: String) {
    getMakesByPartialMatch(makeName: $makeName, context: $context) {
      makeCode
      makeName
      nhtsaMakeCode
    }
  }
`;

export const GET_MAKES_BY_PARTIAL_MATCH_FROM_APPROVAL = gql`
  query ($makeName: String!) {
    getMakesByPartialMatchFromApproval(makeName: $makeName) {
      bodyMake {
        makeName
        makeCode
        nhtsaMakeCode
        nhtsaStatus
      }
      makeCode
    }
  }
`;

export const EDIT_MAKE_MODEL_APPROVAL_REQUEST = gql`
  mutation editMakeModelApproval(
    $editMakeModelApprovalRequestInput: MakeModelApprovalRequestEditInput!
  ) {
    editMakeModelApproval(
      editMakeModelApprovalRequestInput: $editMakeModelApprovalRequestInput
    )
  }
`;

export const GET_CHASSIS_MAKES_BY_PARTIAL_MATCH_FROM_APPROVAL = gql`
  query ($makeName: String!) {
    getMakesByPartialMatchFromApproval(makeName: $makeName) {
      chassisMakeCode
      chassisMake {
        makeName
        makeCode
        nhtsaMakeCode
        nhtsaStatus
      }
    }
  }
`;

export const GET_MODELS_BY_PARTIAL_MATCH_FROM_APPROVAL = gql`
  query GetModelsByPartialMatchFromApproval(
    $modelName: String!
    $makeCode: Float!
    $entrySource: [Int!]
  ) {
    getModelsByPartialMatchFromApproval(
      modelName: $modelName
      makeCode: $makeCode
      entrySource: $entrySource
    ) {
      bodyModel {
        modelCode
        modelName
        nhtsaModelCode
      }
      modelCode
      makeCode
    }
  }
`;

export const GET_CHASSIS_MODELS_BY_PARTIAL_MATCH_FROM_APPROVAL = gql`
  query GetModelsByPartialMatchFromApproval(
    $modelName: String!
    $makeCode: Float!
    $entrySource: [Int!]
  ) {
    getModelsByPartialMatchFromApproval(
      modelName: $modelName
      makeCode: $makeCode
      entrySource: $entrySource
    ) {
      chassisModel {
        modelCode
        modelName
        nhtsaModelCode
      }
      chassisModelCode
      chassisMakeCode
    }
  }
`;

export const GET_MODELS_BY_PARTIAL_MATCH = gql`
  query GetModelsByPartialMatch(
    $makeCode: Int!
    $modelName: String!
    $context: String
  ) {
    getModelsByPartialMatch(
      makeCode: $makeCode
      modelName: $modelName
      context: $context
    ) {
      modelCode
      modelName
      nhtsaModelCode
    }
  }
`;

export const GET_MAKES_AND_MODELS = gql`
  query ($offset: Float, $limit: Float, $filters: [Filter!], $order: OrderBy) {
    getFilteredModels(
      offset: $offset
      limit: $limit
      filters: $filters
      order: $order
    ) {
      count
      hasMore
      rows {
        modelCode
        nhtsaModelCode
        modelName
        makeCode
        nhtsaStatus
        fleetStatus
        entrySource
        fleetApprovedByUser
        createdAt
        make {
          makeCode
          nhtsaMakeCode
          makeName
          nhtsaStatus
          fleetStatus
          entrySource
        }
        comments {
          id
          comment
          action
          createdAt
          createdBy
          createdByUser {
            email
            fullName
          }
        }
      }
    }
  }
`;

export const GET_MAKE_MODEL_APPROVAL = gql`
  query ($offset: Float, $limit: Float, $filters: [Filter!], $order: OrderBy) {
    getFilteredMakeModelApprovals(
      offset: $offset
      limit: $limit
      filters: $filters
      order: $order
    ) {
      count
      hasMore
      rows {
        bodyMake {
          makeCode
          makeName
          nhtsaMakeCode
          entrySource
        }
        bodyModel {
          modelCode
          modelName
          nhtsaModelCode
          entrySource
        }
        chassisMake {
          makeCode
          makeName
          nhtsaMakeCode
          entrySource
        }
        chassisModel {
          modelCode
          modelName
          nhtsaModelCode
          entrySource
        }
        entrySource
        makeModelApprovalId
        makeCode
        modelCode
        chassisMakeCode
        chassisModelCode
        fleetApprovalStatus
        createdAt
        comments {
          id
          comment
          action
          createdAt
          createdBy
          createdByUser {
            email
            fullName
          }
        }
      }
    }
  }
`;

export const APPROVE_REJECT_MAKE_MODEL = gql`
  mutation approveRejectMakeModel(
    $makeModelApprovalInput: MakeModelApprovalInput!
  ) {
    approveRejectMakeModel(makeModelApprovalInput: $makeModelApprovalInput) {
      makeModelApprovalId
      makeCode
      modelCode
      chassisMakeCode
      chassisModelCode
      fleetApprovalStatus
    }
  }
`;

export const APPROVE_REJECT_MODEL = gql`
  mutation updateModelFleetStatus(
    $modelCode: String!
    $fleetStatus: Float!
    $comment: String!
  ) {
    updateModelFleetStatus(
      modelCode: $modelCode
      fleetStatus: $fleetStatus
      comment: $comment
    ) {
      makeCode
      modelCode
      modelName
      fleetStatus
    }
  }
`;

export const GET_BID_LINES_BY_MAKE_MODEL = gql`
  query getBidLinesByMakeAndModel(
    $makeModelSearchInput: MakeModelSearchInput!
  ) {
    getBidLinesByMakeAndModel(makeModelSearchInput: $makeModelSearchInput) {
      id
      bidId
      makeCode
      modelCode
      solicitationLine {
        solicitationProgram {
          program
          solicitationId
          solicitation {
            solicitationNumber
          }
        }
      }
      createdByUser
    }
  }
`;

export const GET_BID_LINES_BY_MAKE_MODEL_FOR_APPROVAL = gql`
  query getBidLinesByMakeAndModel(
    $makeModelSearchInput: MakeModelSearchInput!
  ) {
    getBidLinesByMakeAndModel(makeModelSearchInput: $makeModelSearchInput) {
      id
      bidId
      createdByUser
      vehicleSupplierUser {
        email
      }
      bid {
        solicitationPeriodId
      }
      solicitationLine {
        solicitationProgram {
          solicitation {
            solicitationPeriods {
              id
              endDate
            }
          }
        }
      }
    }
  }
`;

export const GET_PRE_BID_SELECTION_BY_MAKE_MODEL_FOR_APPROVAL = gql`
  query getPreBidMakeModels(
    $modelCode: String!
    $makeCode: Float!
    $chassisModelCode: String
    $chassisMakeCode: Float
  ) {
    getPreBidMakeModels(
      modelCode: $modelCode
      makeCode: $makeCode
      chassisModelCode: $chassisModelCode
      chassisMakeCode: $chassisMakeCode
    ) {
      id
      preBidSelection {
        vendorDetail {
          id
          emailAddress
        }
      }
    }
  }
`;

export const EDIT_MAKE_MODEL = gql`
  mutation EditMakeModel($editMakeModelInput: EditMakeModelInput!) {
    editMakeModel(editMakeModelInput: $editMakeModelInput)
  }
`;

export const ADD_MAKE_MODEL = gql`
  mutation AddMakeModelByEngineer(
    $addMakeModelByEngineerInput: AddMakeModelInput!
  ) {
    addMakeModelByEngineer(
      addMakeModelByEngineerInput: $addMakeModelByEngineerInput
    ) 
  }
`;
